import { stringify } from 'qs';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IDealDocument } from '../types';

interface IGetDocumentsQueryParams {
  documentIds: number[];
  options?: { enabled?: boolean };
}

const getDocumentsByIds = async ({ documentIds }: IGetDocumentsQueryParams): Promise<IDealDocument[]> => {
    const query = stringify({ document_ids: documentIds }, { arrayFormat: 'repeat' });
    const response = await axiosInstance.get(`${API_ENDPOINTS.DEAL_DOCUMENTS.DOCUMENTS}?${query}`);
    return response.data;
};

export const useGetDocumentsByIds = ({ documentIds, options = {} }: IGetDocumentsQueryParams) => useQuery({
    queryKey: [QUERY_KEYS.DOCUMENTS, documentIds],
    queryFn: () => getDocumentsByIds({ documentIds }),
    refetchOnMount: true,
    placeholderData: keepPreviousData,
    ...options,
});

export default useGetDocumentsByIds;
